/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2026 Rochester Software Associates (service@rocsoft.com)
 */

import { useSelector } from 'react-redux';

const FooterCopyrightLine = () => {
    const user = useSelector((state) => state.currentUser);

    const copyrightMessage = user?.copyrightMessage?.replaceAll('&copy;', '©') || '';

    return (
        <div className="footer-copyright">
            {copyrightMessage}
        </div>
    );
};

export default FooterCopyrightLine;
